export enum SignRequestStatus {
  Signed = 'signed',
  Pending = 'pending',
}
